export function identity(value) {
    return value;
}
